import React from 'react'
import { ViewStyle } from 'react-native'

import styled from 'styled-components/native'

import { tID } from '@lyrahealth-inc/ui-core-crossplatform/src/utils/utils'

type MessengerUtilityItemHeaderProps = React.PropsWithChildren<{
  style?: ViewStyle
}>

const Container = styled.View(({ theme }) => ({
  flexDirection: 'column',
  flex: 1,
  backgroundColor: theme.colors.backgroundSecondary,
}))

const MessengerUtilityItemContainer: React.FC<MessengerUtilityItemHeaderProps> = ({ style, children }) => {
  return (
    <Container style={style} testID={tID('MessengerUtilityItemContainer')}>
      {children}
    </Container>
  )
}

export default MessengerUtilityItemContainer
